import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { REGEX_PATTERNS } from '../../../../../auth/config/constants';
import { Messages } from '../../../../../auth/config/messages';
import { Isupport } from '../../../../../auth/models/IUser';
import { AlertService } from '../../../../../core/services/alert.service';
import {
  LogLevel,
  LoggerService,
} from '../../../../../core/services/logger.service';
import { OnboardingService } from '../services/onboarding.service';

@Component({
  selector: 'app-dailog',
  templateUrl: './support.component.html',
  styleUrl: './support.component.scss',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FlexLayoutModule,
    CommonModule,
    MatProgressSpinnerModule,
  ],
})
export class SupportComponent implements OnInit {
  supportForm!: FormGroup;
  isLoading = false;
  constructor(
    private readonly supportSurvice: OnboardingService,
    private readonly alertService: AlertService,
    private readonly logger: LoggerService,
    public readonly dialogRef: MatDialogRef<SupportComponent>
  ) {}
  ngOnInit(): void {
    this.formInitialization();
  }
  formInitialization() {
    this.supportForm = new FormGroup({
      firstName: new FormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(40),
        Validators.pattern(REGEX_PATTERNS.CUSTOM_NAME_PATTERN),
      ]),
      lastName: new FormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(40),
        Validators.pattern(REGEX_PATTERNS.CUSTOM_NAME_PATTERN),
      ]),
      contact: new FormControl('', [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(10),
        Validators.pattern(REGEX_PATTERNS.ALLOW_NUMBERS_PATTERN),
      ]),
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(REGEX_PATTERNS.EMAIL),
      ]),
      mesage: new FormControl('', [Validators.maxLength(1000)]),
    });
  }

  get userFirstName() {
    return this.supportForm.controls['firstName'];
  }
  get userLastName() {
    return this.supportForm.controls['lastName'];
  }
  get userContact() {
    return this.supportForm.controls['contact'];
  }
  get userEmail() {
    return this.supportForm.controls['email'];
  }

  get userMessage() {
    return this.supportForm.controls['mesage'].value;
  }

  submitSupportForm = () => {
    if (this.supportForm.invalid) return;
    const request: Isupport = {
      first_Name: this.userFirstName.value,
      last_Name: this.userLastName.value,
      mobile_Number: String(this.userContact.value),
      email_Address: this.userEmail.value,
      message: this.userMessage,
    };
    this.isLoading = true;
    this.supportSurvice.saveSupportForm(request).subscribe({
      next: response => {
        if (response) this.dialogRef.close();
        this.isLoading = false;
        this.alertService.showAlert(
          Messages.Support_Success_Message,
          'success'
        );
      },
      error: error => {
        this.isLoading = false;
        this.logger.log(LogLevel.ERROR, error);
        this.alertService.showAlert(
          Messages.Support_Failed_Messages,
          'warning'
        );
      },
    });
  };
}
